import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import Vant from 'vant'
import Router from 'vue-router'
import router from './router/index'
import MrImg from '@/components/AlbumImg/'
import MrCard from '@/components/Card/'
import MrVideo from '@/components/Video/'
import MrShare from '@/components/Share/'
import MrTimeline from '@/components/Timeline/'
import filters from './filters/index'
import { Lazyload } from 'vant'
import 'vant/lib/index.css'
import './style/index.scss'
import '@/icons'
import './permission'

Vue.use(Router).use(Vant).use(MrImg).use(MrCard).use(Lazyload).use(MrVideo).use(MrShare).use(MrTimeline)
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))
Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
